import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, BookOpen, Sparkles } from "lucide-react";
import QuoteForm from "@/components/QuoteForm";
import { Reveal } from "./Reveal";

// Premium "Créer mon voyage" entry: Concierge conversationnel en avant,
// formulaire classique en repli (secondaire).
export const CreerMonVoyage = () => {
  const [showForm, setShowForm] = useState(false);
  const openConcierge = () => window.dispatchEvent(new CustomEvent("dt:concierge-open", { detail: {} }));

  return (
    <section id="devis" className="bg-white py-24 md:py-28 px-6 md:px-12 border-t border-[#EAE8E3]" data-testid="creer-mon-voyage-section">
      <div className="max-w-[1000px] mx-auto text-center">
        <Reveal>
          <p className="label-eyebrow">Créer mon voyage sur-mesure</p>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-4">Parlons de votre prochain voyage.</h2>
          <p className="mt-6 text-[#737373] leading-relaxed max-w-2xl mx-auto">
            Décrivez-nous votre projet en quelques minutes. Notre Concierge DealTravel vous accompagne
            pour préparer votre demande, puis votre Travel Planner prend le relais afin de concevoir
            un voyage entièrement sur-mesure.
          </p>

          <div className="mt-9 flex flex-col items-center gap-4">
            <button onClick={openConcierge} data-testid="start-conversation-cta"
              className="inline-flex items-center gap-3 bg-[#1A1B18] text-[#FAF9F6] px-8 py-4 text-[11px] uppercase tracking-[0.28em] hover:bg-[#96836B] transition-colors">
              <MessageCircle className="h-4 w-4" /> Commencer la conversation
            </button>
            <button onClick={() => setShowForm((s) => !s)} data-testid="toggle-classic-form"
              className="text-[11px] uppercase tracking-[0.22em] text-[#96836B] hover:text-[#1A1B18] transition-colors underline underline-offset-4">
              {showForm ? "Masquer le formulaire" : "Je préfère remplir le formulaire classique"}
            </button>
          </div>

          <div className="mt-10 border border-[#EAE8E3] bg-[#FAF9F6] px-6 py-5 max-w-2xl mx-auto flex items-start gap-3 text-left">
            <Sparkles className="h-4 w-4 text-[#96836B] shrink-0 mt-0.5" strokeWidth={1.5} />
            <p className="text-sm text-[#1A1B18] leading-relaxed">
              Un véritable <strong>Travel Planner</strong> vous accompagnera personnellement. Le Concierge
              DealTravel prépare simplement votre demande afin que votre conseiller puisse vous proposer
              un voyage parfaitement adapté à vos envies.
            </p>
          </div>

          <Link to="/devis/demo-premium-devis" target="_blank" data-testid="carnet-example-link"
            className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#96836B] hover:text-[#1A1B18] transition-colors">
            <BookOpen className="h-4 w-4" /> Découvrir un exemple de Carnet de Voyage
          </Link>
        </Reveal>

        {showForm && (
          <div className="mt-14 text-left" data-testid="classic-form-wrap">
            <QuoteForm />
          </div>
        )}
      </div>
    </section>
  );
};

export default CreerMonVoyage;
